module.exports = __webpack_public_path__ + "static/media/zadania-matematyczne-klasa-8-m2.80ff4338.jpg";